import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import roleService from './roleService'

// Get roles
export const getRoles = createAsyncThunk('role/role-list', async (params: {}, thunkAPI) => {
  try {
    return await roleService.getRoles({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get permissions
export const getPermissions = createAsyncThunk('role/get-permissions', async (_, thunkAPI) => {
  try {
    return await roleService.getPermissions()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create new role
export const createRole = createAsyncThunk('role/create-role', async (data: {}, thunkAPI) => {
  try {
    return await roleService.createRole({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get role by id
export const editRole = createAsyncThunk('role/get-role', async (id: string, thunkAPI) => {
  try {
    return await roleService.EditRole(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})
// Get all roles
export const getRole = createAsyncThunk('role/fetch-roles', async (_, thunkAPI) => {
  try {
    return await roleService.getAllRole()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete role
export const deleteRole = createAsyncThunk('role/delete', async (role_id: string, thunkAPI) => {
  try {
    return await roleService.deleteRole(role_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Role Types
type RoleState = {
  roles: any
  role: any
  permission_list: any
  singleRole: any
  errors: any
}

const initialState: RoleState = {
  roles: {
    data: [],
  },
  role: [],
  permission_list: [],
  singleRole: {},
  errors: '',
}

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoles.fulfilled, (state, action: PayloadAction<any>) => {
        state.roles = action.payload
      })
      .addCase(getRole.fulfilled, (state, action: PayloadAction<any>) => {
        state.roles = action.payload
      })
      .addCase(editRole.fulfilled, (state, action: PayloadAction<any>) => {
        state.role = action.payload
        state.singleRole = action.payload
      })
      .addCase(getPermissions.fulfilled, (state, action: PayloadAction<any>) => {
        state.permission_list = action.payload
      })
      .addCase(createRole.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = roleSlice.actions
export default roleSlice.reducer
